<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  rightData2: {
    type: Array,
    default: () => [],
  },
  rightData2Cur:{
    type: Number,
    default: () => 0,
  }
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.rightData2,props.rightData2Cur);
});


function initChart(data,rightData2Cur) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  let defaultData = [50, 60, 70, 20, 30];
  let className = ['1月', '2月', '3月', '4月', '5月'];
  let colorList = ['#39B3FF'];
  const option= {
    grid: {
      left: '5%',
      right: '10%',
      bottom: '0%',
      top: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'none'
      },
      formatter: function (params) {
        return params[0].name + '<br/>' +
          "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
          params[0].seriesName + ' : ' + params[0].value + '%'
      }
    },
    xAxis: {
      show: true,
      type: 'value',
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgba(8,42,42,1)",
          width:2
        },
      },
        axisLabel: {
        show: true,
        textStyle: {
          color: '#fff',
          fontSize:26
        },
      },
    },
    yAxis: [{
      type: 'category',
      inverse: true,
      axisLabel: {
        show: true,
        textStyle: {
          color: '#fff',
          fontSize:26
        },
      },
      splitLine: {
        show: true,
        lineStyle:{
          color:"rgba(8,42,42,1)",
          width:2
        }

      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: className
    }],
    series: [{
      name: '同比增长比例',
      type: 'bar',
      zlevel: 1,
      itemStyle: {
        normal: {
          barBorderRadius: 0,
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0,
              color: "rgba(6, 147, 119, 0)",
            },
              {
                offset: 1,
                color: "rgba(6, 147, 119, 1)",
              },
            ],
          },

        },
      },
      label: {
        show: true, // 显示标签
        position: 'right',
        fontSize: 30,
        color: '#fff',
        offset: [10, 0],
        formatter: '{c} %',
      },
      barWidth: 20,
      emphasis: {
        disabled: true,
        focus: 'none'
      },
      data: defaultData
    },
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
